/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

import { Card } from '@edx/paragon';

import { useIsCollapsed } from './hooks';
import CourseCardImage from './components/CourseCardImage';
import CourseCardActions from './components/CourseCardActions';
import CourseCardDetails from './components/CourseCardDetails';
import CourseCardTitle from './components/CourseCardTitle';
import CourseCardMenu from './components/CourseCardMenu';
import CourseCardBanners from './components/CourseCardBanners';
import CertificateBanner from './components/CourseCardBanners/CertificateBanner';
import { reduxHooks } from 'hooks';


import './CourseCard.scss';
import { tail } from 'lodash';


export const CourseCard = ({
  cardId,
}) => {
  const isCollapsed = useIsCollapsed();
  const orientation = isCollapsed ? 'vertical' : 'horizontal';
  const { isEnrolled } = reduxHooks.useCardEnrollmentData(cardId);
  return (
    <div className="course-card  r4c-dashboard-course-card" id={cardId} data-testid="CourseCard" style={{ borderRadius: '29px' }}>
      <Card orientation={orientation}>
        <div className="d-flex flex-column w-100">
          <div {...(!isCollapsed && { className: 'd-flex', })}>
            <CourseCardImage cardId={cardId} orientation="horizontal" />
            <div className='r4c-dashboard_card_body_wrapper'>
              <Card.Body className="r4c-dashboard_card_body">
                <Card.Header
                  className="r4c-dashboard_card_header"
                  title={<CourseCardTitle cardId={cardId} />}
                  actions={<CourseCardMenu cardId={cardId}  className="r4c-dashboard-card-actions"/>}
                />
                <Card.Section className="pt-0 mt-4">
                  <CourseCardDetails cardId={cardId} />
                </Card.Section>
                {isEnrolled && <CertificateBanner cardId={cardId} />}
                <Card.Footer orientation={orientation} className="r4c-dashboard-card-footer">
                  <CourseCardActions cardId={cardId} />
                </Card.Footer>
              </Card.Body>
            </div>
          </div>
          <CourseCardBanners cardId={cardId} /> 
        </div>
      </Card>
    </div>
  );
};
CourseCard.propTypes = {
  cardId: PropTypes.string.isRequired,
};

export default CourseCard;
